module.exports = __webpack_public_path__ + "img/irelia.815b65b3.jpg";